import { render, staticRenderFns } from "./icon-country-flag.vue?vue&type=template&id=63b2356e&scoped=true&"
import script from "./icon-country-flag.vue?vue&type=script&lang=js&"
export * from "./icon-country-flag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2356e",
  null
  
)

export default component.exports